<script lang="ts">
import { Container } from 'inversify'
import { computed, defineComponent } from 'vue'

import { StatusType } from '@collector/sportsapi-client-legacy'
import EventHeader from '@mobile/views/Relation/Shared/EventHeader/EventHeader.vue'
import Popup from '@mobile/views/Relation/Shared/Popup/Popup.vue'
import { bindSeasonParticipants } from '@mobile/views/Relation/Shared/RelationDependencies/bindSeasonParticipants'
import { bindSkins } from '@mobile/views/Relation/Shared/RelationDependencies/bindSkins'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import VerifyResults from '@mobile/views/Relation/Shared/VerifyResults/VerifyResults.vue'
import LiveView from '@mobile/views/Relation/Sports/Soccer/LiveView/LiveView.vue'
import { bindAssignableIncidentConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindAssignableIncidentConfiguration'
import { bindEventClockConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindEventClockConfiguration'
import { bindEventHeaderConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindEventHeaderConfiguration'
import { bindEventStatusesConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindEventStatusesConfiguration'
import { bindEventStatusesList } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindEventStatusesList'
import { bindIncidentHandlersConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindIncidentHandlersConfiguration'
import { bindIncidentsConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindIncidentsConfiguration'
import { bindIncidentsResultConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindIncidentsResultConfiguration'
import { bindLineupsConfiguration } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindLineupsConfiguration'
import { bindPossessionSide } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindPossessionSide'
import { bindRelationHooks } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/bindRelationHooks'
import { SoccerRelationIoCBindings } from '@mobile/views/Relation/Sports/Soccer/SoccerRelationDependencies/SoccerRelationDependencies'

import { bindDisabledIncidentsWithSameTime } from './SoccerRelationDependencies/bindDisabledIncidentsWithSameTime'
import { bindExpectedGoalsZonesMatrix } from './SoccerRelationDependencies/bindExpectedGoalsZonesMatrix'
import { bindIncidentSequencesEnabledWithSameTime } from './SoccerRelationDependencies/bindInicidentSequencesEnabledWithSameTime'

export default defineComponent({
  components: {
    VerifyResults,
    LiveView,
    Popup,
    EventHeader,
  },
  setup() {
    const { probableEvent } = useEventInjections()

    const displayVerifyResults = computed(() => {
      const probableRelationStatus = probableEvent.value?.status_type

      return probableRelationStatus === StatusType.Finished
    })

    return { displayVerifyResults }
  },
})

export function bindSoccerRelationDependencies(
  ioc: Container,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
): Record<any, any> {
  bindEventStatusesConfiguration(ioc)
  bindIncidentHandlersConfiguration(ioc)
  bindEventStatusesList(ioc)
  bindIncidentsConfiguration(ioc)
  bindIncidentsResultConfiguration(ioc)
  bindSeasonParticipants(ioc)
  bindLineupsConfiguration(ioc)
  bindAssignableIncidentConfiguration(ioc)
  bindRelationHooks(ioc)
  bindEventHeaderConfiguration(ioc)
  bindEventClockConfiguration(ioc)
  bindSkins(ioc)

  // soccer specific bindings
  bindPossessionSide(ioc)
  bindDisabledIncidentsWithSameTime(ioc)
  bindIncidentSequencesEnabledWithSameTime(ioc)
  bindExpectedGoalsZonesMatrix(ioc)

  return SoccerRelationIoCBindings
}
</script>

<template>
  <Popup />
  <EventHeader />
  <VerifyResults v-if="displayVerifyResults" />
  <LiveView v-else />
</template>
